export default __webpack_public_path__ + "static/launch-partner_meebits_right@2x-96a857aa480cda47883969aadc86dd9f.jpg";